export { default as ProductsElasticSearchContentSidebar } from './ProductsElasticSearchContentSidebar';
